import { loanKeyDatesApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_KEY_DATES_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/loanKeyDates`,
  {
    GET_LOAN_KEY_DATES: 'GET_LOAN_KEY_DATES',
  },
);

export const getLoanKeyDatesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanKeyDatesApi.getInfo(params);

  return dispatch({
    type: LOAN_KEY_DATES_ACTION_TYPE.GET_LOAN_KEY_DATES,
    payload: data,
  });
});
